import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { CartStateService } from '../../services/cart-state.service';

export interface MetroHeaderItem {
  label?: string;            // texto visible (opcional, muchos headers son solo íconos)
  iconSvg?: string;          // ícono (igual que nav)
  path?: string;             // para navegar
  disabled?: boolean;

  // Menú desplegable
  children?: MetroHeaderItem[];
  iconName?:string;
}


@Component({
  selector: 'app-metro-header',
  templateUrl: './metro-header.component.html',
  standalone: false
})
export class MetroHeaderComponent {
  @Input() logoSrc = 'assets/images/logo/logo-landscape.png';
  @Input() items: MetroHeaderItem[] = [];
  @Input() cartCount = 0;

  @Output() navigate = new EventEmitter<string>();
  @Output() action = new EventEmitter<MetroHeaderItem>();

  openMenus: Set<string> = new Set();
  currentPath = '';

  constructor(private sanitizer: DomSanitizer, private router: Router, private cartStateService: CartStateService) {
    this.currentPath = this.normalizeUrl(this.router.url);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentPath = this.normalizeUrl(event.urlAfterRedirects);
    });
  }


  goToHome() {
    this.router.navigate(['/']);
  }

  getIconSvg(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  onClick(item: MetroHeaderItem) {
    if (item.children?.length) {
      this.toggleMenu(item.label || item.path || '');
      return;
    }
    if (!item.disabled) {
      if (item.path) this.navigate.emit(item.path);
      this.action.emit(item);
    }
  }

  toggleMenu(key: string) {
    if (this.openMenus.has(key)) this.openMenus.delete(key);
    else this.openMenus.add(key);
  }

  isMenuOpen(key: string) {
    return this.openMenus.has(key);
  }

  private normalizeUrl(url: string): string {
    if (!url) return '';
    const base = url.split('?')[0].split('#')[0];
    if (!base) return '';
    if (base !== '/' && base.endsWith('/')) {
      return base.slice(0, -1);
    }
    return base;
  }

  isItemActive(item: MetroHeaderItem): boolean {
    if (!item.path) return false;
    const normalizedPath = this.normalizeUrl(item.path);
    return normalizedPath.length > 0 && normalizedPath === this.currentPath;
  }

  trackByLabel = (_: number, it: MetroHeaderItem) => it.label || it.path;
}

